// extracted by mini-css-extract-plugin
export default {"containerPrincipal":"Profissionais_containerPrincipal__G7+KX"};